import {
    differenceInDays,
    differenceInMinutes,
    differenceInMonths,
    differenceInWeeks,
    format,
    isValid,
    parseISO
} from 'date-fns';
import {
    ADMIN_LANG
} from "../../settings";


const currentDate = () => new Date();

export const getFormattedDate = (date: string | Date) => {
    if (date === "" || date === null || date === undefined) {
        return null;
    }

    if (typeof date === "string") {
        const parsedDate = parseISO(date);
        return isValid(parsedDate) ? parsedDate : currentDate();
    }

    return isValid(date) ? date : currentDate();
};

export function downloadBlob(blob: Blob, fileName: string) {
    const dataURL = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(dataURL);
}

export function formatRelativeDate(dateString: string): string {
    const now = new Date();
    const date = new Date(dateString);
    const diffInMinutes = differenceInMinutes(now, date);

    const getPluralForm = (value: number, singular: string, plural: string) =>
        value === 1 ? singular : plural;

    if (diffInMinutes === 0) {
        return ADMIN_LANG.just_now;
    } else if (diffInMinutes < 60) {
        return `${diffInMinutes} min`;
    } else if (diffInMinutes < 1440) {
        return `${Math.floor(diffInMinutes / 60)} h`;
    } else if (differenceInDays(now, date) < 7) {
        const days = differenceInDays(now, date);
        return `${days} ${getPluralForm(days, ADMIN_LANG.day, ADMIN_LANG.days)}`;
    } else if (differenceInWeeks(now, date) < 4) {
        const weeks = differenceInWeeks(now, date);
        return `${weeks} ${getPluralForm(weeks, ADMIN_LANG.week, ADMIN_LANG.weeks)}`;
    } else {
        const months = differenceInMonths(now, date);
        return `${months} ${getPluralForm(months, ADMIN_LANG.month, ADMIN_LANG.months)}`;
    }
}

export const formatDate = (dateString: string): string => {
    try {
        const date = new Date(dateString);
        return format(date, 'dd.MM.yyyy');
    } catch (e) {
        return '';
    }
};

export const formatDuration = (secondsStr: string): string => {
    if (secondsStr) {
        const totalSeconds = parseInt(secondsStr, 10);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (hours) {
            return minutes
                ? `${hours} h ${minutes} ${ADMIN_LANG.min}`
                : `${hours} h`;
        } else if (minutes) {
            return seconds
                ? `${minutes} ${ADMIN_LANG.min} ${seconds} ${ADMIN_LANG.sec}`
                : `${minutes} ${ADMIN_LANG.min}`;
        }
        return `${seconds} ${ADMIN_LANG.sec}`;
    }
    return '-';
};


export const formatDateTime = (dateString: string): string => {
    if(!dateString) return '';
    try {
        const date = new Date(dateString);
        return format(date, 'dd.MM.yyyy HH:mm');
    }   catch (e) {
        return '';
    }
}